import React from 'react';
import { cn } from './lib/utils';

/* Inline notice — parity with legacy `~co/common/alert`.
   Variants map to the app's *-background-color theme vars; colored
   variants keep the legacy dark-on-tint text/link treatment. */
const variants = {
  default: 'ui-alert bg-sidebar',
  success:
    'ui-alert-colored bg-[var(--success-background-color)] text-black/70',
  warning:
    'ui-alert-colored bg-[var(--warning-background-color)] text-black/70',
  danger:
    'ui-alert-colored bg-[var(--danger-background-color)] text-black/70',
};

export function Alert({ className, variant = 'default', children, ...props }) {
  return (
    <div
      {...props}
      className={cn(
        'rounded-lg px-[calc(var(--padding-small)+var(--padding-mini))] py-[var(--padding-small)] shadow-[inset_0_0_0_var(--shadow-height)_var(--shadow-color)]',
        variants[variant],
        className,
      )}
    >
      {variant === 'warning' && <span>⚠️&nbsp;</span>}
      {children}
    </div>
  );
}
